import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { AppConfigService, loadAppConfig } from './app/core/config/app-config.service';

loadAppConfig().then((config) => {
    if (config.production) {
        enableProdMode();
    }

    const googleContainerIdWithQuotationMark = "'" + config.googleTagContainerId + "'";

    if (config.googleTagId) {
        const scriptSrc = document.createElement('script');
        scriptSrc.async = true;
        scriptSrc.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.googleTagId;
        document.head.appendChild(scriptSrc);
    }

    if (config.googleTagContainerId) {
        const script2 = document.createElement('script');
        script2.innerHTML = `  (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', ${googleContainerIdWithQuotationMark});`;
        document.head.appendChild(script2);

        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=' + config.googleTagContainerId);
        iframe.setAttribute('height', '0');
        iframe.setAttribute('width', '0');
        iframe.setAttribute('style', 'display: none; visibility: hidden');
        noscript.appendChild(iframe);
        document.head.appendChild(noscript);
    }

    if (config.reCaptchaSiteKey) {
        const reCaptchaScript = document.createElement('script');
        reCaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + config.reCaptchaSiteKey;
        document.head.appendChild(reCaptchaScript);

        const reCaptchaExecuteFunction = document.createElement('script');
        reCaptchaExecuteFunction.innerHTML = ` function onClick(e) {
            e.preventDefault();
            grecaptcha.ready(function() {
              grecaptcha.execute('${config.reCaptchaSiteKey}', {action:'submit'}).then(function(token) {
              });
            });
          }`;
        document.head.appendChild(reCaptchaExecuteFunction);
    }

    bootstrapApplication(AppComponent, createAppConfig()).catch((err) => console.error(err));
});

export function getOrderBackendUrl(): string {
    return new AppConfigService().config.backendOrderUrl;
}
export function getEmailBackendUrl(): string {
    return new AppConfigService().config.backendEmailUrl;
}
export function getStoreBackendUrl(): string {
    return new AppConfigService().config.backendStoreUrl;
}
export function getApiUrl(): string {
    return new AppConfigService().config.apiUrl;
}
export function getBackendAuthUrl(): string {
    return new AppConfigService().config.backendAuthUrl;
}
export function getProduction(): boolean {
    return new AppConfigService().config.production;
}
export function getDownloadFileUrl(): string {
    return new AppConfigService().config.downloadUrl;
}
export function getConfiguratorUrl(): string {
    return new AppConfigService().config.backendConfiguratorUrl;
}
export function getfileBaseUrl(): string {
    return new AppConfigService().config.fileBaseUrl;
}
export function getDeliveryUrl(): string {
    return new AppConfigService().config.backendDeliveryUrl;
}
